import { Component, OnInit, Inject, AfterViewInit, ViewChild, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { animate, state, style, transition, trigger } from '@angular/animations';
import * as $ from 'jquery';
import { GrowerOrderService } from './../../../../../services/seed/growerOrder.service';
import { ConfigService } from './../../../../../services/infrastructure/config.service';
import { GrowerOrderData } from './../../../../../models/GrowerOrderData';
import { AccountVM } from './../../../../../models/AccountMasterVM';
import { AddEditOrderDetailComponent } from '../add-edit-order/add-edit-order.component';
import { SliderModelService } from './../../../../../services/infrastructure/sliderModel.service';
import { BroadcastService } from './../../../../../services/infrastructure/broadcaster.service';
import { LocalStorageService } from './../../../../../services/infrastructure/local-storage.service';
import { MasterConstants } from './../../../../../common/constants/master-constants';
import { ErrorStateMatcher } from '@angular/material/core';
import { UntypedFormControl, FormGroupDirective, NgForm } from '@angular/forms';
import { Subscription } from 'rxjs';
import { LolLoggerService } from '../../../../../common/shared/lol-logger.service';
import { CommonService } from '../../../../../services/common/common.service';
import { GrowerPdfGenerate } from '../grower-pdf-generate/grower-pdf-generate.component';

@Component({
    selector: 'app-growerorderdetail',
    templateUrl: './grower-order-details.component.html',
    styleUrls: ['./grower-order-details.component.scss'],
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({ height: '0px', minHeight: '0', display: 'none' })),
            state('expanded', style({ height: '*' })),
            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ])
    ]
})

export class GrowerOrderDetailComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild(AddEditOrderDetailComponent) addEditOrderDetail: AddEditOrderDetailComponent;
  @ViewChild('pdfGenerator') pdfGenerator: GrowerPdfGenerate;

    generatePdf() {
      this.pdfGenerator.generatePdf();
    }
    private subscription = new Array<Subscription>();

    showGrowerInfo: Boolean;
    showAccInfo: Boolean;
    SelGrowerObj: GrowerOrderData;
    getGrowerOrderId: string;
    SelAccountObj: AccountVM;
    public errorMsgs = new Array();
    public currentErrorRow = 1;
    public nextErrorId = 0;
    index = 0;
    updatedProductList: any;
    showErrorBlock = false;
    accountNo = 0;
    public selectedGrowerAccId: any = 0;
    headerYear: string;
    headerCompany = MasterConstants.US_COMPANYCODE;
    emailPattern: any = MasterConstants.INDIVIDUAL_EMAIL_PATTERN;
    accountEmail: string;
    isInvalidEmail = false;
    disableOnLock = false;
    accessTypeMode = false;
    matcher = new InputErrorStateMatcher(this.isInvalidEmail);
    isSubscriptionAccess = true;
    selGrowerOrderId: number;
    selGrowerAccountNumber: number;
    isMobile = /Android|iPhone/i.test(window.navigator.userAgent);
    constructor(private growerOrderService: GrowerOrderService,
        @Inject('BASE_URL') public baseUrl: any,
        private activatedRoute: ActivatedRoute,
        private sliderModelService: SliderModelService,
        private configService: ConfigService,
        public broadcastService: BroadcastService,
        private localStorageService: LocalStorageService,
        private commonService: CommonService) {
        this.showAccInfo = false;
        this.showGrowerInfo = false;

        if (this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR)) {
            this.headerYear = JSON.parse(this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR));
        }
    }

    ngOnInit(): void {
        // Set the default value
        if (this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR)) {
            this.headerYear = JSON.parse(this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR));
        }

        // Get Grower Order Id from URL
        this.subscription.push(this.activatedRoute.params.subscribe(x => {
            this.errorMsgs = [];
            let paramGrowerOrderId = 0, paramAccountId = 0;
            if (x['growerOrderId']) {
                paramGrowerOrderId = +x['growerOrderId'];
              this.getGrowerAccount(x['growerOrderId']);
              this.selGrowerOrderId = paramGrowerOrderId;
            }
            if (x['accountNo']) {
                paramAccountId = + x['accountNo'];
              this.accountNo = x['accountNo'];
              this.selGrowerAccountNumber = paramAccountId;
            }

            // Created broadcast service for select the grower detail in the left panel
            this.broadcastService.broadcast(this.configService.PARAM_GROWER_ORDER, { growerOrderId: paramGrowerOrderId, accountId: paramAccountId });
        }));

        if (this.localStorageService.get(MasterConstants.EVOLVE_ACCESS)) {
            const data = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
            if (data !== null && data !== undefined && data.resultData.length > 0) {
                const isActiveUser = data.resultData.find(x => x.userIdCompanyCode == this.headerCompany);
                if (!isActiveUser.isSubscriptionAccess) {
                    this.isSubscriptionAccess = false;
                    this.accountEmail = isActiveUser.emailId;
                } else {
                    this.isSubscriptionAccess = true;
                }
            }
        }

        this.subscription.push(this.broadcastService.on<any>(this.configService.NAVIGATE_TO_BREADCRUMB).subscribe((data) => {
            if (data
                && data.naigateToBreadCrumb == true) {
                this.SelGrowerObj = null;
                this.SelAccountObj = null;
            }
        }));

        this.accessTypeMode = false;
        setTimeout(x => {
            this.accessTypeMode = this.commonService.checkUserRoleAccessType(MasterConstants.FUNCTION_CODE.FULFILLMENT_TAB);
        }, 500);
    }

    // Get All Account List
    GetAccountList(accountNo: string) {
        this.subscription.push(this.growerOrderService.getAccounts().subscribe((result: any[]) => {
            const data = result.filter(x => x.accountNumber == accountNo);
            if (data[0]) {
                const obj = data[0];
                this.growerOrderService.AccountChange({
                    accountName: obj.accountName,
                    accountNumber: obj.accountNumber,
                    accountType: obj.accountType,
                    billingAddressType: obj.billingAddressType,
                    address1: obj.address1,
                    address2: obj.address2,
                    emailAddress: obj.emailAddress,
                    city: obj.city,
                    state: obj.state,
                    zipCode: obj.zipCode,
                    isAccountRIB: false
                });
                this.SelAccountObj = this.growerOrderService.SelectedAccountObj.value;
            }
        }, error => { LolLoggerService.error(error); }));
    }
    // Get All Grower Orders Accounts
    getGrowerAccount(growerOrderId: string) {
        this.getGrowerOrderId = growerOrderId;
        if (growerOrderId != '') {
            this.subscription.push(this.growerOrderService.getGrowerList(this.headerYear, '0', growerOrderId)
                .subscribe((resp: any[]) => {
                    const data = resp.filter(x => x.growerOrderID == growerOrderId);
                    if (data[0]) {
                        // var obj = data[0];
                        const growerObj = new GrowerOrderData();
                        growerObj.growerOrderId = data[0].growerOrderID;
                        growerObj.growerName = data[0].growerName;
                        growerObj.orderID = data[0].orderNumber;
                        growerObj.growerAddress = data[0].address;
                        growerObj.city = data[0].city;
                        growerObj.state = data[0].state;
                        growerObj.zip = data[0].zipCode;
                        growerObj.lastUpdatedAt = data[0].createTimestamp;
                        growerObj.accountNo = data[0].shipToAccount;
                        growerObj.orderType = data[0].orderType,
                            growerObj.gln = data[0].growerGLN;
                        growerObj.gmk = data[0].growerGMK;
                        growerObj.EmailTo = data[0].emailAddress;
                        growerObj.wfusB2BEnablement = data[0].wfusB2BEnablement;
                        growerObj.isAccountRIB = data[0].isAccountRIB;
                        this.GetAccountList(growerObj.accountNo);
                        this.growerOrderService.GrowerChange(growerObj);
                        this.SelGrowerObj = growerObj;
                        this.growerOrderService.SelectedGrowerObj.value;
                        this.selectedGrowerAccId = growerObj.accountNo;
                        this.sliderModelService.selectedGrowerAccountId(this.selectedGrowerAccId);
                        this.disableOnLock = (this.SelGrowerObj.orderType != 'WB' && this.SelGrowerObj.orderID !== '');

                        if (this.localStorageService.get(MasterConstants.EVOLVE_ACCESS)) {
                            const evolveAccess = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
                            if (evolveAccess !== null && evolveAccess !== undefined && evolveAccess.resultData.length > 0) {
                                const isActiveUser = evolveAccess.resultData.find(x => x.userIdCompanyCode == this.headerCompany);
                                if (isActiveUser.isSubscriptionAccess) {
                                    this.accountEmail = data[0].emailAddress;
                                }
                            }
                        }
                    }
                }, (error => {
                    LolLoggerService.error(error);
                })));
        }
        if (this.localStorageService.get(MasterConstants.EVOLVE_ACCESS)) {
            const data = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
            if (data !== null && data !== undefined && data.resultData.length > 0) {
                const isActiveUser = data.resultData.find(x => x.userIdCompanyCode == this.headerCompany);
                if (!isActiveUser.isSubscriptionAccess) {
                    this.accountEmail = isActiveUser.emailId;
                }
            }
        }
    }

    ngAfterViewInit() {
        // Set Dynamic Height of Panels
        this.setHeight();
    }
    // Design : Start
    setHeight() {
        const templateHeight = window.innerHeight - $('.search-section').outerHeight() - 64;
        $('.order-view-sec').css('max-height', templateHeight + 'px');

        const GrowerAddSecHeight = window.innerHeight - $('.search-section').outerHeight() - 96;
        $('.order-view-sec .grower-add-sec').css('min-height', GrowerAddSecHeight + 'px');
    }
    // Design : End
    // Error handling : Start
    nextError() {
        this.index = this.errorMsgs.findIndex(x => x.rowId == this.nextErrorId) + 1;
        if (this.errorMsgs.indexOf(this.errorMsgs[this.index]) != -1) {
            this.nextErrorId = this.errorMsgs[this.index].rowId;
            this.currentErrorRow = this.index + 1;
            $('#orderView').scrollTop = 0;
            if ($('#error_' + this.nextErrorId.toString()).offset()) {
                const nextOffset = $('#error_' + this.nextErrorId.toString()).offset().top;
                $('#orderView').animate({ scrollTop: nextOffset }, 1000);
            }
        }
        else {
            this.index = 0;
            this.nextErrorId = this.errorMsgs[this.index].rowId;
            this.currentErrorRow = 1;
            $('#orderView').scrollTop = 0;
            $('#orderView').animate({ scrollTop: 0 }, 1000);
        }
    }

    getCommonErrors(errors: any) {
        if (errors && errors.length > 0) {
            this.errorMsgs = [];
            this.index = 0;
            this.currentErrorRow = 1;
            this.errorMsgs = errors;
            this.showErrorBlock = true;
        }
        else {
            this.showErrorBlock = false;
        }
    }

    hideCommonError() {
        this.showErrorBlock = false;
    }

    revertAllChanges() {
        this.addEditOrderDetail.RevertToPrevious([], false);
        this.hideCommonError();
    }

    // Validate the email address entered
    validateEmail() {
        this.isInvalidEmail = this.commonService.validateEmail(this.accountEmail, true);
        this.addEditOrderDetail.isInvalidEmail = false;
        if (this.isInvalidEmail) {
            this.addEditOrderDetail.isInvalidEmail = true;
        }
        else {
            this.SelGrowerObj.EmailTo = this.accountEmail;
        }
        this.matcher = new InputErrorStateMatcher(this.isInvalidEmail);
  }
    ngOnDestroy() {
        this.subscription.forEach(subscription => subscription.unsubscribe());
    }
}

class InputErrorStateMatcher implements ErrorStateMatcher {
    constructor(private errorstate: boolean) { }
    isErrorState(control: UntypedFormControl | null, form: FormGroupDirective | NgForm | null): boolean {
        return this.errorstate;
    }
}
